import { render } from "./PosteVerte.vue?vue&type=template&id=6f190ad8&scoped=true&ts=true"
import script from "./PosteVerte.vue?vue&type=script&lang=ts"
export * from "./PosteVerte.vue?vue&type=script&lang=ts"

import "./PosteVerte.vue?vue&type=style&index=0&id=6f190ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f190ad8"]])

export default __exports__